export default "__VITE_ASSET__4a5895d9__"